"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDuplicateAccepter = exports.isValidAccepterResponses = exports.serialiseAccepterResponses = exports.deserialiseAccepterResponses = void 0;
var zod_1 = require("zod");
var UniqueId_1 = __importDefault(require("@CommonFrontendBackend/Utils/UniqueId"));
var hubspotFieldSchema = zod_1.z
    .object({
    name: zod_1.z.string().min(1),
    apiName: zod_1.z.string().min(1),
})
    .optional();
var actionConfig = zod_1.z.object({
    accepters: zod_1.z.array(zod_1.z.object({
        name: zod_1.z.object({
            hubspotField: hubspotFieldSchema,
        }),
        email: zod_1.z.object({
            hubspotField: hubspotFieldSchema,
        }),
        organization: zod_1.z.object({
            hubspotField: hubspotFieldSchema,
        }),
        customForm: zod_1.z
            .array(zod_1.z.object({
            customFormFieldId: zod_1.z.string().min(1),
            hubspotField: hubspotFieldSchema,
        }))
            .optional(),
    })),
    customFormId: zod_1.z.string().optional(),
});
var isValidAccepterResponses = function (config) {
    return actionConfig.safeParse(config).success;
};
exports.isValidAccepterResponses = isValidAccepterResponses;
var deserialiseAccepterResponses = function (config, field) {
    var defaultConfig = {
        accepters: [
            {
                name: {},
                email: {},
                organization: {},
            },
        ],
    };
    var _a = !isValidAccepterResponses(config) ? defaultConfig : config, accepters = _a.accepters, customFormId = _a.customFormId;
    var customForm = field.customForms.find(function (form) { return form.id === customFormId; });
    return {
        accepters: accepters.map(function (accepter) {
            var fieldsById = new Map();
            fieldsById.set("name", {
                id: "name",
                name: "Name",
                deleted: false,
                to: accepter.name.hubspotField
                    ? {
                        name: accepter.name.hubspotField.name,
                        apiName: accepter.name.hubspotField.apiName,
                    }
                    : undefined,
            });
            fieldsById.set("email", {
                id: "email",
                name: "Email",
                deleted: false,
                to: accepter.email.hubspotField
                    ? {
                        name: accepter.email.hubspotField.name,
                        apiName: accepter.email.hubspotField.apiName,
                    }
                    : undefined,
            });
            fieldsById.set("organization", {
                id: "organization",
                name: "Organization",
                deleted: false,
                to: accepter.organization.hubspotField
                    ? {
                        name: accepter.organization.hubspotField.name,
                        apiName: accepter.organization.hubspotField.apiName,
                    }
                    : undefined,
            });
            if (customForm) {
                customForm.fields.forEach(function (field) {
                    if (!fieldsById.has(field.id)) {
                        fieldsById.set(field.id, {
                            id: field.id,
                            name: field.name,
                            deleted: false,
                        });
                    }
                });
            }
            if (accepter.customForm) {
                accepter.customForm.forEach(function (_a) {
                    var customFormFieldId = _a.customFormFieldId, hubspotField = _a.hubspotField;
                    var field = fieldsById.get(customFormFieldId);
                    if (field) {
                        fieldsById.set(field.id, __assign(__assign({}, field), { to: hubspotField
                                ? {
                                    name: hubspotField.name,
                                    apiName: hubspotField.apiName,
                                }
                                : undefined }));
                    }
                    else if (hubspotField) {
                        fieldsById.set(customFormFieldId, {
                            id: customFormFieldId,
                            name: "",
                            deleted: true,
                            to: hubspotField
                                ? {
                                    name: hubspotField.name,
                                    apiName: hubspotField.apiName,
                                }
                                : undefined,
                        });
                    }
                });
            }
            return { guid: (0, UniqueId_1.default)(), fields: __spreadArray([], __read(fieldsById.values()), false) };
        }),
        customFormId: customFormId,
        customForm: customForm,
    };
};
exports.deserialiseAccepterResponses = deserialiseAccepterResponses;
var serialiseAccepterResponses = function (data, _a) {
    var _b = _a === void 0 ? { resetCustomForm: false } : _a, resetCustomForm = _b.resetCustomForm;
    return {
        accepters: data.accepters.map(function (_a) {
            var fields = _a.fields;
            var _b = __read(fields), name = _b[0], email = _b[1], organization = _b[2], customForm = _b.slice(3);
            return {
                name: {
                    hubspotField: name.to ? { name: name.to.name, apiName: name.to.apiName } : undefined,
                },
                email: {
                    hubspotField: email.to ? { name: email.to.name, apiName: email.to.apiName } : undefined,
                },
                organization: {
                    hubspotField: organization.to ? { name: organization.to.name, apiName: organization.to.apiName } : undefined,
                },
                customForm: resetCustomForm
                    ? data.customForm
                        ? data.customForm.fields.map(function (field) { return ({ customFormFieldId: field.id }); })
                        : undefined
                    : customForm
                        ? customForm.map(function (field) { return ({
                            customFormFieldId: field.id,
                            hubspotField: field.to ? { name: field.to.name, apiName: field.to.apiName } : undefined,
                        }); })
                        : undefined,
            };
        }),
        customFormId: data.customForm ? data.customForm.id : undefined,
    };
};
exports.serialiseAccepterResponses = serialiseAccepterResponses;
var createDuplicateAccepter = function (accepter) { return ({
    guid: (0, UniqueId_1.default)(),
    fields: accepter.fields
        .filter(function (field) { return !field.deleted; })
        .map(function (field) { return ({
        id: field.id,
        name: field.name,
        deleted: field.deleted,
    }); }),
}); };
exports.createDuplicateAccepter = createDuplicateAccepter;
